import {ClassType} from "./ClassType";
import {RootClass} from "../class-structure/RootClass";
import {playClassPool} from "../../utils/PlayClassPool";

export interface PanelConfig {
  panelSelectedClassId: number|null,
  activeClassId: number|null,
}

export type PanelConfigs = {
  [K in ClassType]?: PanelConfig
}

export class ClassPanelStatus {
  selectedPanelType: ClassType = 'PIANO_BOTH';
  panelConfigs: PanelConfigs = {
  }

  setActiveClassId(classId: number) {
    if (this.panelConfigs![this.selectedPanelType]) {
      this.panelConfigs![this.selectedPanelType]!.activeClassId = classId;
    }
  }

  static createFromJson(pieceVersionUserAccess: any, rootClass: RootClass) {
    const classPanelStatus = new ClassPanelStatus();
    getRootClassContentTypeWithResumeData(rootClass).forEach((classType) => {
      classPanelStatus.panelConfigs[classType] = {
        panelSelectedClassId: null,
        activeClassId: null,
      };
      classPanelStatus.panelConfigs[classType]!.panelSelectedClassId = rootClass.content[classType]!.containedClasses[0].id;
    })

    if (pieceVersionUserAccess && pieceVersionUserAccess.class_resume_status) {
      if (pieceVersionUserAccess.class_resume_status.selectedPanelType) {
        classPanelStatus.selectedPanelType = pieceVersionUserAccess.class_resume_status.selectedPanelType === 'CONSOLIDATION' ? 'PIANO_BOTH' : pieceVersionUserAccess.class_resume_status.selectedPanelType;
      }
      getRootClassContentTypeWithResumeData(rootClass).forEach((classType) => {
        if (pieceVersionUserAccess.class_resume_status.panelConfigs?.[classType]?.panelSelectedClassId) {
          if (playClassPool.exists(pieceVersionUserAccess.class_resume_status.panelConfigs[classType].panelSelectedClassId)) {
            classPanelStatus.panelConfigs[classType]!.panelSelectedClassId = pieceVersionUserAccess.class_resume_status.panelConfigs[classType].panelSelectedClassId;
          }
        }
        if (pieceVersionUserAccess.class_resume_status.panelConfigs?.[classType]?.activeClassId) {
          if (playClassPool.exists(pieceVersionUserAccess.class_resume_status.panelConfigs[classType].activeClassId)) {
            classPanelStatus.panelConfigs[classType]!.activeClassId = pieceVersionUserAccess.class_resume_status.panelConfigs[classType].activeClassId;
          }
        }
      })
    }

    return classPanelStatus;
  }
}

export const classPanelStatusTypesWithResumeData: ClassType[] = ['PIANO_BOTH', 'SING']
function getRootClassContentTypeWithResumeData(rootClass: RootClass): ClassType[] {
  return (Object.keys(rootClass.content) as ClassType[]).filter(
    (classType: ClassType) => classPanelStatusTypesWithResumeData.includes(classType)
  );
}
